export default __webpack_public_path__ + "static/media/InvoiceIcon.02792c21.svg";